export type PasswordConfiguration = 'simple' | 'medium' | 'complex';

/**
 * api-users falls back to the weakest policy when an organization has no stored value,
 * so anything we display before/instead of a successful fetch has to be this same value —
 * otherwise the policy shown to an admin is not the one enforced when a password is set.
 */
export const DEFAULT_PASSWORD_CONFIGURATION: PasswordConfiguration = 'simple';

export interface PasswordConfigurationState {
	value: PasswordConfiguration;
	/**
	 * The RTDB-backed `isLoaded(organization)` gate does not cover this value any more, so
	 * consumers need their own readiness flag. Rendering the radio before this flips would
	 * show `simple` and let a save in that window persist the wrong policy.
	 */
	isLoaded: boolean;
	isLoading: boolean;
	isSaving: boolean;
	error: string | null;
}
